/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PowSolutionParser = /* #__PURE__ */ parsers.object([
    ['nonce', codecString],
    ['solution', codecString],
]);
export class PowSolution extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PowSolutionParser.decode(input).map(res => new PowSolution(res));
    }
    static unsafeDecode(input) {
        return PowSolution.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PowSolutionParser.encode(data);
    }
    static schema() {
        return PowSolutionParser.schema();
    }
}
